<section class="content-section">

  <!-- ── En-tête ───────────────────────────────────────────────────── -->
  <div class="page-header">
    <div class="page-header-left">
      <div class="page-header-icon">
        <i class="fal fa-medal"></i>
      </div>
      <div>
        <h2>Niveaux Livreur</h2>
        <p>Configurez les paliers et les primes mensuelles associées.</p>
      </div>
    </div>
    <button class="btn-nouveau" (click)="ouvrir()">
      <i class="fal fa-plus"></i>
      <span>Nouveau niveau</span>
    </button>
  </div>

  <!-- ── Formulaire ─────────────────────────────────────────────────── -->
  <div *ngIf="afficherFormulaire" class="form-card">

    <div class="form-card-header">
      <div class="form-card-title">
        <i class="fal fa-{{ editId ? 'edit' : 'plus-circle' }}"></i>
        {{ editId ? 'Modifier le niveau' : 'Nouveau niveau' }}
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="enregistrer()" class="nv-form">

      <!-- Ligne 1 : Nom, Seuil, Ordre -->
      <div class="nv-row">
        <div class="nv-field">
          <label class="nv-label">
            Nom du niveau
            <span class="required-dot">*</span>
          </label>
          <input class="nv-input"
                 formControlName="nom"
                 placeholder="ex. BRONZE"
                 [class.nv-input--error]="form.get('nom')?.invalid && form.get('nom')?.touched">
          <span class="nv-hint" *ngIf="form.get('nom')?.invalid && form.get('nom')?.touched">
            Ce champ est requis.
          </span>
        </div>

        <div class="nv-field">
          <label class="nv-label">
            Seuil min. de courses
            <span class="required-dot">*</span>
          </label>
          <div class="nv-input-addon">
            <input class="nv-input nv-input--num"
                   type="number"
                   formControlName="seuilMinCourses"
                   min="0">
            <span class="nv-addon-text">courses</span>
          </div>
        </div>

        <div class="nv-field">
          <label class="nv-label">
            Ordre d'affichage
            <span class="required-dot">*</span>
          </label>
          <input class="nv-input nv-input--num"
                 type="number"
                 formControlName="ordre"
                 min="1">
        </div>
      </div>

      <!-- Ligne 2 : Couleur, Emoji -->
      <div class="nv-row nv-row--2col">
        <div class="nv-field">
          <label class="nv-label">Couleur du badge</label>
          <div class="nv-color-row">
            <label class="nv-color-swatch-label">
              <input type="color" class="nv-color-native"
                     [value]="form.get('couleur')?.value"
                     (input)="form.get('couleur')?.setValue($any($event.target).value)">
              <span class="nv-color-preview" [style.background]="form.get('couleur')?.value"></span>
            </label>
            <input class="nv-input nv-input--hex"
                   formControlName="couleur"
                   maxlength="7"
                   placeholder="#CD7F32">
          </div>
        </div>

        <div class="nv-field">
          <label class="nv-label">Emoji / Icône</label>
          <div class="nv-emoji-row">
            <span class="nv-emoji-preview">{{ form.get('emoji')?.value || '⭐' }}</span>
            <input class="nv-input"
                   formControlName="emoji"
                   placeholder="🥉"
                   maxlength="8">
          </div>
        </div>
      </div>

      <!-- Ligne 3 : Primes -->
      <div class="nv-primes-section">
        <div class="nv-primes-header">
          <i class="fal fa-gift"></i>
          Primes mensuelles
        </div>
        <div class="nv-row nv-row--2col">
          <div class="nv-field">
            <label class="nv-label">Prime fixe mensuelle</label>
            <div class="nv-input-addon">
              <input class="nv-input nv-input--num"
                     type="number"
                     formControlName="primeFixeMensuelle"
                     min="0">
              <span class="nv-addon-text">FCFA</span>
            </div>
          </div>

          <div class="nv-field">
            <label class="nv-label">Prime sur chiffre d'affaires</label>
            <div class="nv-input-addon">
              <input class="nv-input nv-input--num"
                     type="number"
                     formControlName="primePourcentageCa"
                     min="0" max="100" step="0.1">
              <span class="nv-addon-text">%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Aperçu -->
      <div class="nv-preview" *ngIf="form.get('nom')?.value">
        <span class="nv-preview-label">Aperçu</span>
        <span class="niveau-badge"
              [style.background]="(form.get('couleur')?.value || '#888') + '20'"
              [style.color]="form.get('couleur')?.value || '#888'"
              [style.border-color]="(form.get('couleur')?.value || '#888') + '55'">
          {{ form.get('emoji')?.value || '⭐' }}
          {{ form.get('nom')?.value | uppercase }}
        </span>
      </div>

      <!-- Actions -->
      <div class="nv-actions">
        <button type="button" class="btn-annuler" (click)="fermer()">
          <i class="fal fa-times"></i> Annuler
        </button>
        <button type="submit" class="btn-enregistrer" [disabled]="enregistrement || form.invalid">
          <i class="fal fa-{{ enregistrement ? 'spinner fa-spin' : 'check' }}"></i>
          {{ enregistrement ? 'Enregistrement…' : 'Enregistrer' }}
        </button>
      </div>

    </form>
  </div>

  <!-- ── Chargement ─────────────────────────────────────────────────── -->
  <div *ngIf="chargement" class="loading-state">
    <div class="spinner"></div>
    <span>Chargement des niveaux…</span>
  </div>

  <!-- ── Tableau des niveaux ────────────────────────────────────────── -->
  <ng-container *ngIf="!chargement">

    <ng-container *ngIf="niveaux.length; else vide">
      <div class="niveaux-grid">
        <div class="niveau-card" *ngFor="let n of niveaux; trackBy: trackById"
             [style.--nv-color]="n.couleur || '#888'">
          <div class="niveau-card-top">
            <div class="niveau-emoji">{{ n.emoji || '⭐' }}</div>
            <div class="niveau-card-meta">
              <div class="niveau-card-nom">{{ n.nom }}</div>
              <div class="niveau-card-seuil">≥ {{ n.seuilMinCourses | number }} courses</div>
            </div>
            <div class="niveau-card-actions">
              <button class="icon-btn icon-btn--edit" (click)="ouvrir(n)" matTooltip="Modifier">
                <i class="fal fa-pencil"></i>
              </button>
              <button class="icon-btn icon-btn--delete" (click)="supprimer(n.id!)" matTooltip="Supprimer">
                <i class="fal fa-trash-alt"></i>
              </button>
            </div>
          </div>
          <div class="niveau-card-divider"></div>
          <div class="niveau-card-primes">
            <div class="prime-item">
              <i class="fal fa-coins"></i>
              <div>
                <div class="prime-val">{{ n.primeFixeMensuelle | number:'1.0-0' }} FCFA</div>
                <div class="prime-lab">Prime fixe</div>
              </div>
            </div>
            <div class="prime-sep"></div>
            <div class="prime-item">
              <i class="fal fa-percentage"></i>
              <div>
                <div class="prime-val">{{ n.primePourcentageCa }}%</div>
                <div class="prime-lab">du CA mensuel</div>
              </div>
            </div>
          </div>
          <div class="niveau-card-ordre">Niveau {{ n.ordre }}</div>
        </div>
      </div>
    </ng-container>

    <ng-template #vide>
      <div class="empty-state">
        <div class="empty-icon">
          <i class="fal fa-layer-group"></i>
        </div>
        <h3>Aucun niveau configuré</h3>
        <p>Créez les paliers (BRONZE, ARGENT, OR, PLATINE…) pour vos livreurs.</p>
        <p class="empty-default">
          Par défaut le système utilise les seuils : 0 / 50 / 150 / 300 courses.
        </p>
        <button class="btn-nouveau" (click)="ouvrir()">
          <i class="fal fa-plus"></i>
          <span>Créer le premier niveau</span>
        </button>
      </div>
    </ng-template>

  </ng-container>

</section>
